import React from "react";

function AsiaInfo(props) {
  return (
    <div className="col-xs-12 mb-20">
      <div className="bg-white p-30">
        <h4 className="title-green">ASIA</h4>
        <hr />
        <div className="row">
          <div className="col-xs-6">
            <p>Units Demanded Automobile: n/a</p>
            <p>Growth Rate: n/a</p>
          </div>
          <div className="col-xs-6">
            <p>Units Demanded Mobile Phones: n/a</p>
            <p>Growth Rate: n/a</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AsiaInfo;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/market/asia-info.js